import styled from 'styled-components'

export const MainLayout = styled.div`
  display: flex;
  margin-top: 64px;
  min-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

// Área de trabalho: fundo do tema com os cartões por cima e margem enxuta
export const Container = styled.div`
  position: relative;
  flex: 1;
  padding: 16px 20px;
  background: var(--yrm-bg);
  margin-left: 65px; /* Margem inicial para menu recolhido */
  margin-right: auto;
  overflow-x: hidden; /* Remove scroll horizontal */
  overflow-y: hidden;
  transition: margin-left 0.3s ease; /* Transição suave */
  max-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  min-height: 0;
  ${({ $fixedPage }) => $fixedPage && `
    overflow: hidden;
  `}

  @media (max-width: 768px) {
    margin-left: 0 !important; /* Remove margem em mobile */
    margin-right: 0 !important; /* Remove margem direita em mobile */
    padding: 16px 16px 16px 16px; /* Padding igual em todos os lados */
    width: 100vw; /* Força largura total da viewport */
    max-width: 100vw; /* Evita overflow */
    box-sizing: border-box; /* Inclui padding no cálculo da largura */
  }

  @media (min-width: 576px) {
    max-width: 100%;
  }

  @media (min-width: 740px) {
    max-width: 100%;
  }

  @media (min-width: 992px) {
    max-width: 100%;
  }

  @media (min-width: 1200px) {
    max-width: 100%;
  }

  @media (min-width: 1400px) {
    max-width: 100%;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  /* espaço no fim para o botão da Sofia não ficar por cima do último item */
  padding-bottom: 72px;

  @media (max-width: 768px) {
    padding-bottom: 80px;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  ${Container}[data-container="main"][data-fixed-page="true"] & {
    overflow-y: hidden;
    padding-bottom: 0;
  }
`

export const RouteFallback = styled.div`
  min-height: 100%;
  display: grid;
  place-items: center;
  background: var(--yrm-surface);

  > div {
    margin: 0;
  }
`

export const Footer = styled.p`
  text-align: center;
  margin-bottom: 8px;
  margin-top: auto; /* Empurra o footer para o final */
  padding-top: 24px;

  @media (max-width: 361px) {
    font-size: 14px;
  }
`
